import React from 'react';
import { GridFooterContainer, GridPagination } from '@mui/x-data-grid';
import { Box, Button, Typography } from '@mui/material';

const CustomFooterWithLoadMore = ({ hasMoreData, loading, onLoadMore }) => (
<GridFooterContainer sx={{ px: 2, py: 1, overflowX: 'hidden', }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', width: '100%', }} >
    
        {/* Left: Rows per page */}
        <Box sx={{ flex: 1 }} />
        {/* Center: Load More */}
        
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
            {hasMoreData ? (
                <Button variant="contained" onClick={onLoadMore} disabled={loading} sx={{ minWidth: 120 }}>
                    {loading ? 'Loading...' : 'Load More'}
                </Button>
            ) : (<Typography variant="body2" color="text.secondary">No more records </Typography>)}
        </Box>

        {/* Right: Pagination - Increased width */}
        <Box sx={{ flex: 2, minWidth: 250, display: 'flex', justifyContent: 'flex-end' }}>
            <GridPagination />
        </Box>
        
    </Box>
</GridFooterContainer>
);

export default CustomFooterWithLoadMore;
